import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FluentProvider, webDarkTheme, webLightTheme, Text, makeStyles, tokens } from '@fluentui/react-components';
import App from './App';
import CaptureApp from './CaptureApp';
import SignatureApp from './SignatureApp';
import './index.css';

const usePageStyles = makeStyles({
  background: {
    minHeight: '100vh',
    width: '100%',
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: '24px',
    paddingRight: '24px',
    paddingBottom: '24px',
    paddingLeft: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    '@media (max-width: 599px)': {
      paddingTop: '8px',
      paddingRight: '8px',
      paddingBottom: '8px',
      paddingLeft: '8px',
    },
  },
  content: {
    width: '100%',
    maxWidth: '700px',
    minWidth: 0,
  },
});

const PageShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const styles = usePageStyles();
  return (
    <div className={styles.background}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <FluentProvider theme={prefersDark ? webDarkTheme : webLightTheme}>
      <PageShell>
        <BrowserRouter>
          <Routes>
            <Route path="/respond/:requestId" element={<App />} />
            <Route path="/respond/:requestId/r/:responseId" element={<App />} />
            <Route path="/secure/respond/:requestId" element={<App />} />
            <Route path="/secure/respond/:requestId/r/:responseId" element={<App />} />
            <Route path="/capture/:token" element={<CaptureApp />} />
            <Route path="/signature/:token" element={<SignatureApp />} />
            <Route path="*" element={<div style={{ padding: '2rem' }}><Text size={500}>Invalid link. Please use a valid form URL.</Text></div>} />
          </Routes>
        </BrowserRouter>
      </PageShell>
    </FluentProvider>
  </React.StrictMode>
);
